export default __webpack_public_path__ + "static/media/RotacionaKomoraHladnjak.04537d48.png";